import { AnyAction, Dispatch, MiddlewareAPI } from 'redux';

import agentMessageSound from '../../assets/audio/newAgentMessageSound.mp3';
import { MESSAGES } from '../../constants';
import { TRootState } from '../common/reducers';
import { chatActions } from '../common/reducers/chat';
import { PresentedState } from '../common/reducers/types';
import { renderModel } from '../util/renderModel';

class NewAgentMessageSound {
  private readonly audio: HTMLAudioElement = new Audio(agentMessageSound);
  public isPlaying = false;
  public async play(): Promise<void> {
    try {
      this.isPlaying = true;
      await this.audio.play();
    } catch (error) {
      if (error.name !== 'NotAllowedError') {
        throw error;
      }
    } finally {
      this.isPlaying = false;
    }
  }
}

const newAgentMessageSound = new NewAgentMessageSound();

export const soundMiddleware =
  ({ getState }: MiddlewareAPI<any, TRootState>) =>
  (next: Dispatch) =>
  async (action: AnyAction) => {
    if (chatActions.addItem.match(action)) {
      const {
        chat: { isMuted },
        helpCenter: { currentPresentedState },
        widget: { expanded },
      } = getState();

      const isInView = !document.hidden;
      const isAgentMessage = [MESSAGES.AGENT_MESSAGE].includes(action.payload.type);

      if (isAgentMessage && !isMuted && !newAgentMessageSound.isPlaying) {
        if (!isInView) {
          await newAgentMessageSound.play();
        } else if (renderModel.isWidget()) {
          const isChatbotPage = currentPresentedState === PresentedState.Chatbot;

          if (!expanded || (expanded && !isChatbotPage)) {
            await newAgentMessageSound.play();
          }
        }
      }
    }

    return next(action);
  };
